import { render, staticRenderFns } from "./ArmorDummy.vue?vue&type=template&id=fdde6c62&scoped=true"
import script from "./ArmorDummy.vue?vue&type=script&lang=js"
export * from "./ArmorDummy.vue?vue&type=script&lang=js"
import style0 from "./ArmorDummy.vue?vue&type=style&index=0&id=fdde6c62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdde6c62",
  null
  
)

export default component.exports